<div class="{{skin.multiSelectContainer}}">

  <!-- Zone principale cliquable -->
  <div (click)="toggleDropdown()"
    class="{{skin.multiselectSelected}}">

    <!-- Tags selectionnes -->
    <ng-container *ngIf="selectedKeys.length > 0 && isMultiselect">
      @if(!isReactive) {
      <span *ngFor="let key of selectedKeys"
        class="inline-flex items-center gap-1 px-3 py-1 text-sm font-medium text-blue-800 bg-blue-100 rounded-full">
        {{ getLabel(key) }}
        <button type="button"
          (click)="$event.stopPropagation(); removeTag(key)"
          class="ml-1 text-blue-600 hover:text-blue-800 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </span>
      } @else {
      <app-reactive-badge *ngFor="let key of selectedKeys" [status]="getSelectedValue(key)" [Skin]="skin" [iconAdditionalDataName]="reactiveIconAdditionalDataName" (statusChange)="statusChange.emit({ key, status: $event })" (click)="$event.stopPropagation()" [lookupData]="getChildren(key)" (deleteButtonClicked)="removeTag(key)" [isEditMode]="true" [deleteButton]="true"></app-reactive-badge>
      }
    </ng-container>

    <!-- Placeholder -->
    <span class="text-gray-500" *ngIf="selectedKeys.length === 0">{{ placeholder | translate }}...</span>
    <span class="text-gray-800" *ngIf="selectedKeys.length === 1 && !isMultiselect">{{ labelForSingleSelect }}</span>
    <!-- <span class="text-gray-700" *ngIf="selectedKeys.length > 1 || isMultiselect">{{ displayText | translate }} {{'selected' | translate }}</span> -->

    <!-- Fleche -->
    <svg class="ml-auto h-5 w-5 text-gray-400 transition-transform duration-200"
      [class.rotate-180]="isOpen"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor">
      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
    </svg>
  </div>

  <!-- Dropdown -->
  <div *ngIf="isOpen"
    class="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
    <!-- Recherche -->
    <div class="p-2 border-b border-gray-200">
      <input #searchInput type="search" (focus)="true"
        [id]="searchFieldName"
        [name]="searchFieldName"
        autocomplete="new-password"
        [(ngModel)]="searchTerm"
        placeholder="{{ 'Search' | translate }}..."
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        autofocus />
    </div>

    <!-- Options -->
    <ul class="py-1">
      <li *ngFor="let option of filteredOptions"
        (click)="selectOption(option)"
        class="px-4 py-2 text-sm hover:bg-blue-50 cursor-pointer flex items-center justify-between"
        [class.opacity-50]="selectedKeys.includes(option.key) || (maxItems !== null && selectedKeys.length >= maxItems && !selectedKeys.includes(option.key))">
        <span>{{ option.value }}</span>
        <svg *ngIf="selectedKeys.includes(option.key)"
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-blue-600"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </li>
      <li *ngIf="filteredOptions.length === 0 && !allowCreate" class="px-4 py-2 text-sm text-gray-500">
        {{ 'No results found' | translate }}
      </li>
      <li *ngIf="allowCreate && searchTerm.trim()"
        (click)="onCreateNew()"
        class="px-4 py-2 text-sm hover:bg-green-50 cursor-pointer flex items-center gap-2 text-green-700">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
        </svg>
        <span>{{ 'Create' | translate }} "<strong>{{ searchTerm.trim() }}</strong>"</span>
      </li>
    </ul>
  </div>
</div>